import { jsx } from "react/jsx-runtime";
import { ColorBlue500 } from "@nxt-costco-com/forge-design-tokens";
import { Text } from "../../DataDisplay/Text/index.js";
import { Link } from "../Link/index.js";
import { INVALID_PROPS_ERROR, COMPONENT_NAME } from "./constants.js";
import { skipLinkStyles } from "./styles.js";
const SkipLink = ({ targetId, skipLinkText }) => {
  if (!(targetId && skipLinkText)) {
    console.error(INVALID_PROPS_ERROR);
    return null;
  }
  return /* @__PURE__ */ jsx(
    Link,
    {
      href: `#${targetId}`,
      sx: skipLinkStyles,
      "data-testid": `jump-to-${targetId}`,
      children: /* @__PURE__ */ jsx(Text, { variant: "t3", color: ColorBlue500, children: skipLinkText })
    }
  );
};
SkipLink.displayName = COMPONENT_NAME;
export {
  SkipLink
};
